module.exports = __webpack_public_path__ + "img/Tutorial.663f39d0.svg";